module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "author"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v("前端")]), _vm._v("\n        " + _vm._s(_vm.userInfo.showName) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "articleNum"
  }, [_vm._v("\n        文章：" + _vm._s(_vm.articleCount) + "\n        "), _c('span', [_vm._v(" | ")]), _vm._v("\n        字数：" + _vm._s(_vm.wordCount) + "\n      ")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "articleNum"
  }, [_vm._v("\n          访问人数："), _c('span', {
    staticStyle: {
      "color": "#969696"
    }
  }, [_vm._v(_vm._s(_vm.userIpCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "singName",
    domProps: {
      "innerHTML": _vm._s(_vm.userInfo.singName)
    }
  })])]), _vm._v(" "), _c('v-article', {
    attrs: {
      "articleList": _vm.articleList,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "getArticleList": _vm.getArticleList,
      "showMessage": _vm.showMessage,
      "toTag": _vm.toTag
    }
  }), _vm._v(" "), _c('v-sidebar', {
    attrs: {
      "categories": _vm.categories,
      "tags": _vm.tags,
      "nowCategorie": _vm.nowCategorie,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "getColumnArticle": _vm.getColumnArticle,
      "toTag": _vm.toTag
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce988d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/blog/index.vue
// module id = 258
// module chunks = 1